import _ from 'lodash';

import URC from 'ui-react-common';
import * as types from './action-types';

const UserService = URC.services.UserService;
const api = URC.services.coreAPIInstance;

const piiRetry = ({ form, queryParams={} }) => ({
    asyncAction: () =>
        api
            .piiRetry({ form, queryParams })
            .then((response) => {
                const user = _.get(response, 'data.user');
                user && UserService.set(user);
                return response;
            })
            .catch((error) => {
                const user = _.get(error, 'data.user');
                user && UserService.set(user);
                throw error;
            }),
    type: types.PII_RETRY,
});

export default { piiRetry };
